import { render } from "./App.vue?vue&type=template&id=4278f84c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=4278f84c&lang=scss"

import exportComponent from "E:\\workspace_two\\first_web_nologin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__